import { Button, Grid, LinearProgress, useTheme } from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import React from 'react'
import { useHistory, useParams } from 'react-router-dom';
import * as Yup from "yup";
import { TextField as FormikTextField } from "formik-material-ui";

import { useELAssets } from '../../../intake/intakeQueries';
import { EdgeUploadComponent } from './EdgeUploadComponent';
import LSDBFormikAutocompleteField from '../../../common/LSDBFormikAutocompleteField';


export const EdgeFileUpload = () => {

    const theme = useTheme();
    const formikRef = React.useRef<any>();
    const [clearedValues, setClearedValues] = React.useState(false);
    const history = useHistory();



    const {
        error: errorELasset,
        data: ELasset,
        isLoading: isLoadingElAsset,
        isError: isErrorELasset,
    } = useELAssets();



    if (isLoadingElAsset) {
        return <LinearProgress />
    }
    return (
        <>
            <div style={theme.containerMargin}>
                <Grid container direction="column" spacing={2}>
                    <Grid item xs={12}>
                        <Formik
                            innerRef={formikRef}
                            initialValues={{
                                asset_id: null,
                            }}
                            validationSchema={Yup.object({
                                asset_id: Yup.object()
                                    .nullable()
                                    .required("Asset is required"),
                            })}
                            onSubmit={async () => { }}
                        >
                            {({ values }) => {
                                return (
                                    <Form>
                                        <Grid container direction="row" alignItems="center" spacing={2}>
                                            <Grid item xs={6}>
                                                <LSDBFormikAutocompleteField
                                                    fieldId="asset_id"
                                                    fieldName="asset_id"
                                                    fieldDisplayName="Assets"
                                                    fullWidth
                                                    options={ELasset || []}
                                                    getOptionLabel={(asset: any) => asset.name || ""}
                                                    getOptionValue={(asset: any) => asset.id}
                                                />
                                            </Grid>

                                            <Grid item>
                                                <Button
                                                    data-testid="clearSerialNumber"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => {
                                                        formikRef.current?.resetForm({
                                                            values: {
                                                                asset_id: null,
                                                            },
                                                        });

                                                        setClearedValues(false);
                                                    }}
                                                >
                                                    Clear
                                                </Button>
                                            </Grid>
                                        </Grid>

                                        {values.asset_id && (
                                            <Grid container style={{ marginTop: 16 }}>
                                                <Grid item xs={12}>
                                                    <EdgeUploadComponent
                                                        asset={values.asset_id} onSuccess={() => {
                                                            formikRef.current?.resetForm({
                                                                values: {
                                                                    asset_id: null,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </Grid>

                </Grid>
            </div>

        </>
    )
}


